export type CitizenshipModel = { name: string; type: string };

export const codesISO3: CitizenshipModel[] = [
  { name: 'Afghanistan', type: 'AFG' },
  { name: 'Åland Islands', type: 'ALA' },
  { name: 'Albania', type: 'ALB' },
  { name: 'Algeria', type: 'DZA' },
  { name: 'American Samoa', type: 'ASM' },
  { name: 'Andorra', type: 'AND' },
  { name: 'Angola', type: 'AGO' },
  { name: 'Anguilla', type: 'AIA' },
  { name: 'Antarctica', type: 'ATA' },
  { name: 'Antigua and Barbuda', type: 'ATG' },
  { name: 'Argentina', type: 'ARG' },
  { name: 'Armenia', type: 'ARM' },
  { name: 'Aruba', type: 'ABW' },
  { name: 'Australia', type: 'AUS' },
  { name: 'Austria', type: 'AUT' },
  { name: 'Azerbaijan', type: 'AZE' },
  { name: 'Bahamas', type: 'BHS' },
  { name: 'Bahrain', type: 'BHR' },
  { name: 'Bangladesh', type: 'BGD' },
  { name: 'Barbados', type: 'BRB' },
  { name: 'Belarus', type: 'BLR' },
  { name: 'Belgium', type: 'BEL' },
  { name: 'Belize', type: 'BLZ' },
  { name: 'Benin', type: 'BEN' },
  { name: 'Bermuda', type: 'BMU' },
  { name: 'Bhutan', type: 'BTN' },
  { name: 'Bolivia (Plurinational State of)', type: 'BOL' },
  { name: 'Bonaire, Sint Eustatius and Saba', type: 'BES' },
  { name: 'Bosnia and Herzegovina', type: 'BIH' },
  { name: 'Botswana', type: 'BWA' },
  { name: 'Bouvet Island', type: 'BVT' },
  { name: 'Brazil', type: 'BRA' },
  { name: 'British Indian Ocean Territory', type: 'IOT' },
  { name: 'Brunei Darussalam', type: 'BRN' },
  { name: 'Bulgaria', type: 'BGR' },
  { name: 'Burkina Faso', type: 'BFA' },
  { name: 'Burundi', type: 'BDI' },
  { name: 'Cabo Verde', type: 'CPV' },
  { name: 'Cambodia', type: 'KHM' },
  { name: 'Cameroon', type: 'CMR' },
  { name: 'Canada', type: 'CAN' },
  { name: 'Cayman Islands', type: 'CYM' },
  { name: 'Central African Republic', type: 'CAF' },
  { name: 'Chad', type: 'TCD' },
  { name: 'Chile', type: 'CHL' },
  { name: 'China', type: 'CHN' },
  { name: 'Christmas Island', type: 'CXR' },
  { name: 'Cocos (Keeling) Islands', type: 'CCK' },
  { name: 'Colombia', type: 'COL' },
  { name: 'Comoros', type: 'COM' },
  { name: 'Congo', type: 'COG' },
  { name: 'Congo, Democratic Republic of the', type: 'COD' },
  { name: 'Cook Islands', type: 'COK' },
  { name: 'Costa Rica', type: 'CRI' },
  { name: "Côte d'Ivoire", type: 'CIV' },
  { name: 'Croatia', type: 'HRV' },
  { name: 'Cuba', type: 'CUB' },
  { name: 'Curaçao', type: 'CUW' },
  { name: 'Cyprus', type: 'CYP' },
  { name: 'Czechia', type: 'CZE' },
  { name: 'Denmark', type: 'DNK' },
  { name: 'Djibouti', type: 'DJI' },
  { name: 'Dominica', type: 'DMA' },
  { name: 'Dominican Republic', type: 'D' },
  { name: 'Ecuador', type: 'ECU' },
  { name: 'Egypt', type: 'EGY' },
  { name: 'El Salvador', type: 'SLV' },
  { name: 'Equatorial Guinea', type: 'GNQ' },
  { name: 'Eritrea', type: 'ERI' },
  { name: 'Estonia', type: 'EST' },
  { name: 'Eswatini', type: 'SWZ' },
  { name: 'Ethiopia', type: 'ETH' },
  { name: 'Falkland Islands (Malvinas)', type: 'FLK' },
  { name: 'Faroe Islands', type: 'FRO' },
  { name: 'Fiji', type: 'FJI' },
  { name: 'Finland', type: 'FIN' },
  { name: 'France', type: 'FRA' },
  { name: 'French Guiana', type: 'GUF' },
  { name: 'French Polynesia', type: 'PYF' },
  { name: 'French Southern Territories', type: 'ATF' },
  { name: 'Gabon', type: 'GAB' },
  { name: 'Gambia', type: 'GMB' },
  { name: 'Georgia', type: 'GEO' },
  { name: 'Germany', type: 'DEU' },
  { name: 'Ghana', type: 'GHA' },
  { name: 'Gibraltar', type: 'GIB' },
  { name: 'Greece', type: 'GRC' },
  { name: 'Greenland', type: 'GRL' },
  { name: 'Grenada', type: 'GRD' },
  { name: 'Guadeloupe', type: 'GLP' },
  { name: 'Guam', type: 'GUM' },
  { name: 'Guatemala', type: 'GTM' },
  { name: 'Guernsey', type: 'GGY' },
  { name: 'Guinea', type: 'GIN' },
  { name: 'Guinea-Bissau', type: 'GNB' },
  { name: 'Guyana', type: 'GUY' },
  { name: 'Haiti', type: 'HTI' },
  { name: 'Heard Island and McDonald Islands', type: 'HMD' },
  { name: 'Holy See', type: 'VAT' },
  { name: 'Honduras', type: 'HND' },
  { name: 'Hong Kong', type: 'HKG' },
  { name: 'Hungary', type: 'HUN' },
  { name: 'Iceland', type: 'ISL' },
  { name: 'India', type: 'IND' },
  { name: 'Indonesia', type: 'IDN' },
  { name: 'Iran (Islamic Republic of)', type: 'IRN' },
  { name: 'Iraq', type: 'IRQ' },
  { name: 'Ireland', type: 'IRL' },
  { name: 'Isle of Man', type: 'IMN' },
  { name: 'Israel', type: 'ISR' },
  { name: 'Italy', type: 'ITA' },
  { name: 'Jamaica', type: 'JAM' },
  { name: 'Japan', type: 'JPN' },
  { name: 'Jersey', type: 'JEY' },
  { name: 'Jordan', type: 'JOR' },
  { name: 'Kazakhstan', type: 'KAZ' },
  { name: 'Kenya', type: 'KEN' },
  { name: 'Kiribati', type: 'KIR' },
  { name: "Korea (Democratic People's Republic of)", type: 'PRK' },
  { name: 'Korea, Republic of', type: 'KOR' },
  { name: 'Kuwait', type: 'KWT' },
  { name: 'Kyrgyzstan', type: 'KGZ' },
  { name: "Lao People's Democratic Republic", type: 'LAO' },
  { name: 'Latvia', type: 'LVA' },
  { name: 'Lebanon', type: 'LBN' },
  { name: 'Lesotho', type: 'LSO' },
  { name: 'Liberia', type: 'LBR' },
  { name: 'Libya', type: 'LBY' },
  { name: 'Liechtenstein', type: 'LIE' },
  { name: 'Lithuania', type: 'LTU' },
  { name: 'Luxembourg', type: 'LUX' },
  { name: 'Macao', type: 'MAC' },
  { name: 'Madagascar', type: 'MDG' },
  { name: 'Malawi', type: 'MWI' },
  { name: 'Malaysia', type: 'MYS' },
  { name: 'Maldives', type: 'MDV' },
  { name: 'Mali', type: 'MLI' },
  { name: 'Malta', type: 'MLT' },
  { name: 'Marshall Islands', type: 'MHL' },
  { name: 'Martinique', type: 'MTQ' },
  { name: 'Mauritania', type: 'MRT' },
  { name: 'Mauritius', type: 'MUS' },
  { name: 'Mayotte', type: 'MYT' },
  { name: 'Mexico', type: 'MEX' },
  { name: 'Micronesia (Federated States of)', type: 'FSM' },
  { name: 'Moldova, Republic of', type: 'MDA' },
  { name: 'Monaco', type: 'MCO' },
  { name: 'Mongolia', type: 'MNG' },
  { name: 'Montenegro', type: 'MNE' },
  { name: 'Montserrat', type: 'MSR' },
  { name: 'Morocco', type: 'MAR' },
  { name: 'Mozambique', type: 'MOZ' },
  { name: 'Myanmar', type: 'MMR' },
  { name: 'Namibia', type: 'NAM' },
  { name: 'Nauru', type: 'NRU' },
  { name: 'Nepal', type: 'NPL' },
  { name: 'Netherlands', type: 'NLD' },
  { name: 'New Caledonia', type: 'NCL' },
  { name: 'New Zealand', type: 'NZL' },
  { name: 'Nicaragua', type: 'NIC' },
  { name: 'Niger', type: 'NER' },
  { name: 'Nigeria', type: 'NGA' },
  { name: 'Niue', type: 'NIU' },
  { name: 'Norfolk Island', type: 'NFK' },
  { name: 'North Macedonia', type: 'MKD' },
  { name: 'Northern Mariana Islands', type: 'MNP' },
  { name: 'Norway', type: 'NOR' },
  { name: 'Oman', type: 'OMN' },
  { name: 'Pakistan', type: 'PAK' },
  { name: 'Palau', type: 'PLW' },
  { name: 'Palestine, State of', type: 'PSE' },
  { name: 'Panama', type: 'PAN' },
  { name: 'Papua New Guinea', type: 'PNG' },
  { name: 'Paraguay', type: 'PRY' },
  { name: 'Peru', type: 'PER' },
  { name: 'Philippines', type: 'PHL' },
  { name: 'Pitcairn', type: 'PCN' },
  { name: 'Poland', type: 'POL' },
  { name: 'Portugal', type: 'PRT' },
  { name: 'Puerto Rico', type: 'PRI' },
  { name: 'Qatar', type: 'QAT' },
  { name: 'Réunion', type: 'REU' },
  { name: 'Romania', type: 'ROU' },
  { name: 'Russian Federation', type: 'RUS' },
  { name: 'Rwanda', type: 'RWA' },
  { name: 'Saint Barthélemy', type: 'BLM' },
  { name: 'Saint Helena, Ascension and Tristan da Cunha', type: 'SHN' },
  { name: 'Saint Kitts and Nevis', type: 'KNA' },
  { name: 'Saint Lucia', type: 'LCA' },
  { name: 'Saint Martin (French part)', type: 'MAF' },
  { name: 'Saint Pierre and Miquelon', type: 'SPM' },
  { name: 'Saint Vincent and the Grenadines', type: 'VCT' },
  { name: 'Samoa', type: 'WSM' },
  { name: 'San Marino', type: 'SMR' },
  { name: 'Sao Tome and Principe', type: 'STP' },
  { name: 'Saudi Arabia', type: 'SAU' },
  { name: 'Senegal', type: 'SEN' },
  { name: 'Serbia', type: 'SRB' },
  { name: 'Seychelles', type: 'SYC' },
  { name: 'Sierra Leone', type: 'SLE' },
  { name: 'Singapore', type: 'SGP' },
  { name: 'Sint Maarten (Dutch part)', type: 'SXM' },
  { name: 'Slovakia', type: 'SVK' },
  { name: 'Slovenia', type: 'SVN' },
  { name: 'Solomon Islands', type: 'SLB' },
  { name: 'Somalia', type: 'SOM' },
  { name: 'South Africa', type: 'ZAF' },
  { name: 'South Georgia and the South Sandwich Islands', type: 'SGS' },
  { name: 'South Sudan', type: 'SSD' },
  { name: 'Spain', type: 'ESP' },
  { name: 'Sri Lanka', type: 'LKA' },
  { name: 'Sudan', type: 'SDN' },
  { name: 'Suriname', type: 'SUR' },
  { name: 'Svalbard and Jan Mayen', type: 'SJM' },
  { name: 'Sweden', type: 'SWE' },
  { name: 'Switzerland', type: 'CHE' },
  { name: 'Syrian Arab Republic', type: 'SYR' },
  { name: 'Taiwan, Province of China', type: 'TWN' },
  { name: 'Tajikistan', type: 'TJK' },
  { name: 'Tanzania, United Republic of', type: 'TZA' },
  { name: 'Thailand', type: 'THA' },
  { name: 'Timor-Leste', type: 'TLS' },
  { name: 'Togo', type: 'TGO' },
  { name: 'Tokelau', type: 'TKL' },
  { name: 'Tonga', type: 'TON' },
  { name: 'Trinidad and Tobago', type: 'TTO' },
  { name: 'Tunisia', type: 'TUN' },
  { name: 'Turkey', type: 'TUR' },
  { name: 'Turkmenistan', type: 'TKM' },
  { name: 'Turks and Caicos Islands', type: 'TCA' },
  { name: 'Tuvalu', type: 'TUV' },
  { name: 'Uganda', type: 'UGA' },
  { name: 'Ukraine', type: 'UKR' },
  { name: 'United Arab Emirates', type: 'ARE' },
  { name: 'United Kingdom of Great Britain and Northern Ireland', type: 'GBR' },
  { name: 'United States of America', type: 'USA' },
  { name: 'United States Minor Outlying Islands', type: 'UMI' },
  { name: 'Uruguay', type: 'URY' },
  { name: 'Uzbekistan', type: 'UZB' },
  { name: 'Vanuatu', type: 'VUT' },
  { name: 'Venezuela (Bolivarian Republic of)', type: 'VEN' },
  { name: 'Viet Nam', type: 'VNM' },
  { name: 'Virgin Islands (British)', type: 'VGB' },
  { name: 'Virgin Islands (U.S.)', type: 'VIR' },
  { name: 'Wallis and Futuna', type: 'WLF' },
  { name: 'Western Sahara', type: 'ESH' },
  { name: 'Yemen', type: 'YEM' },
  { name: 'Zambia', type: 'ZMB' },
  { name: 'Zimbabwe', type: 'ZWE' }
];

export const codesISO2: CitizenshipModel[] = [
  { type: 'AF', name: 'Afghanistan' },
  { type: 'AX', name: 'Aland Islands' },
  { type: 'AL', name: 'Albania' },
  { type: 'DZ', name: 'Algeria' },
  { type: 'AS', name: 'American Samoa' },
  { type: 'AD', name: 'Andorra' },
  { type: 'AO', name: 'Angola' },
  { type: 'AI', name: 'Anguilla' },
  { type: 'AQ', name: 'Antarctica' },
  { type: 'AG', name: 'Antigua And Barbuda' },
  { type: 'AR', name: 'Argentina' },
  { type: 'AM', name: 'Armenia' },
  { type: 'AW', name: 'Aruba' },
  { type: 'AU', name: 'Australia' },
  { type: 'AT', name: 'Austria' },
  { type: 'AZ', name: 'Azerbaijan' },
  { type: 'BS', name: 'Bahamas' },
  { type: 'BH', name: 'Bahrain' },
  { type: 'BD', name: 'Bangladesh' },
  { type: 'BB', name: 'Barbados' },
  { type: 'BY', name: 'Belarus' },
  { type: 'BE', name: 'Belgium' },
  { type: 'BZ', name: 'Belize' },
  { type: 'BJ', name: 'Benin' },
  { type: 'BM', name: 'Bermuda' },
  { type: 'BT', name: 'Bhutan' },
  { type: 'BO', name: 'Bolivia' },
  { type: 'BA', name: 'Bosnia And Herzegovina' },
  { type: 'BW', name: 'Botswana' },
  { type: 'BV', name: 'Bouvet Island' },
  { type: 'BR', name: 'Brazil' },
  { type: 'IO', name: 'British Indian Ocean Territory' },
  { type: 'BN', name: 'Brunei Darussalam' },
  { type: 'BG', name: 'Bulgaria' },
  { type: 'BF', name: 'Burkina Faso' },
  { type: 'BI', name: 'Burundi' },
  { type: 'KH', name: 'Cambodia' },
  { type: 'CM', name: 'Cameroon' },
  { type: 'CA', name: 'Canada' },
  { type: 'CV', name: 'Cape Verde' },
  { type: 'KY', name: 'Cayman Islands' },
  { type: 'CF', name: 'Central African Republic' },
  { type: 'TD', name: 'Chad' },
  { type: 'CL', name: 'Chile' },
  { type: 'CN', name: 'China' },
  { type: 'CX', name: 'Christmas Island' },
  { type: 'CC', name: 'Cocos (Keeling) Islands' },
  { type: 'CO', name: 'Colombia' },
  { type: 'KM', name: 'Comoros' },
  { type: 'CG', name: 'Congo' },
  { type: 'CD', name: 'Congo}, Democratic Republic' },
  { type: 'CK', name: 'Cook Islands' },
  { type: 'CR', name: 'Costa Rica' },
  { type: 'CI', name: "Cote D'Ivoire" },
  { type: 'HR', name: 'Croatia' },
  { type: 'CU', name: 'Cuba' },
  { type: 'CY', name: 'Cyprus' },
  { type: 'CZ', name: 'Czech Republic' },
  { type: 'DK', name: 'Denmark' },
  { type: 'DJ', name: 'Djibouti' },
  { type: 'DM', name: 'Dominica' },
  { type: 'DO', name: 'Dominican Republic' },
  { type: 'EC', name: 'Ecuador' },
  { type: 'EG', name: 'Egypt' },
  { type: 'SV', name: 'El Salvador' },
  { type: 'GQ', name: 'Equatorial Guinea' },
  { type: 'ER', name: 'Eritrea' },
  { type: 'EE', name: 'Estonia' },
  { type: 'ET', name: 'Ethiopia' },
  { type: 'FK', name: 'Falkland Islands (Malvinas)' },
  { type: 'FO', name: 'Faroe Islands' },
  { type: 'FJ', name: 'Fiji' },
  { type: 'FI', name: 'Finland' },
  { type: 'FR', name: 'France' },
  { type: 'GF', name: 'French Guiana' },
  { type: 'PF', name: 'French Polynesia' },
  { type: 'TF', name: 'French Southern Territories' },
  { type: 'GA', name: 'Gabon' },
  { type: 'GM', name: 'Gambia' },
  { type: 'GE', name: 'Georgia' },
  { type: 'DE', name: 'Germany' },
  { type: 'GH', name: 'Ghana' },
  { type: 'GI', name: 'Gibraltar' },
  { type: 'GR', name: 'Greece' },
  { type: 'GL', name: 'Greenland' },
  { type: 'GD', name: 'Grenada' },
  { type: 'GP', name: 'Guadeloupe' },
  { type: 'GU', name: 'Guam' },
  { type: 'GT', name: 'Guatemala' },
  { type: 'GG', name: 'Guernsey' },
  { type: 'GN', name: 'Guinea' },
  { type: 'GW', name: 'Guinea-Bissau' },
  { type: 'GY', name: 'Guyana' },
  { type: 'HT', name: 'Haiti' },
  { type: 'HM', name: 'Heard Island & Mcdonald Islands' },
  { type: 'VA', name: 'Holy See (Vatican City State)' },
  { type: 'HN', name: 'Honduras' },
  { type: 'HK', name: 'Hong Kong' },
  { type: 'HU', name: 'Hungary' },
  { type: 'IS', name: 'Iceland' },
  { type: 'IN', name: 'India' },
  { type: 'ID', name: 'Indonesia' },
  { type: 'IR', name: 'Iran}, Islamic Republic Of' },
  { type: 'IQ', name: 'Iraq' },
  { type: 'IE', name: 'Ireland' },
  { type: 'IM', name: 'Isle Of Man' },
  { type: 'IL', name: 'Israel' },
  { type: 'IT', name: 'Italy' },
  { type: 'JM', name: 'Jamaica' },
  { type: 'JP', name: 'Japan' },
  { type: 'JE', name: 'Jersey' },
  { type: 'JO', name: 'Jordan' },
  { type: 'KZ', name: 'Kazakhstan' },
  { type: 'KE', name: 'Kenya' },
  { type: 'KI', name: 'Kiribati' },
  { type: 'KR', name: 'Korea' },
  { type: 'KW', name: 'Kuwait' },
  { type: 'KG', name: 'Kyrgyzstan' },
  { type: 'LA', name: "Lao People's Democratic Republic" },
  { type: 'LV', name: 'Latvia' },
  { type: 'LB', name: 'Lebanon' },
  { type: 'LS', name: 'Lesotho' },
  { type: 'LR', name: 'Liberia' },
  { type: 'LY', name: 'Libyan Arab Jamahiriya' },
  { type: 'LI', name: 'Liechtenstein' },
  { type: 'LT', name: 'Lithuania' },
  { type: 'LU', name: 'Luxembourg' },
  { type: 'MO', name: 'Macao' },
  { type: 'MK', name: 'Macedonia' },
  { type: 'MG', name: 'Madagascar' },
  { type: 'MW', name: 'Malawi' },
  { type: 'MY', name: 'Malaysia' },
  { type: 'MV', name: 'Maldives' },
  { type: 'ML', name: 'Mali' },
  { type: 'MT', name: 'Malta' },
  { type: 'MH', name: 'Marshall Islands' },
  { type: 'MQ', name: 'Martinique' },
  { type: 'MR', name: 'Mauritania' },
  { type: 'MU', name: 'Mauritius' },
  { type: 'YT', name: 'Mayotte' },
  { type: 'MX', name: 'Mexico' },
  { type: 'FM', name: 'Micronesia}, Federated States Of' },
  { type: 'MD', name: 'Moldova' },
  { type: 'MC', name: 'Monaco' },
  { type: 'MN', name: 'Mongolia' },
  { type: 'ME', name: 'Montenegro' },
  { type: 'MS', name: 'Montserrat' },
  { type: 'MA', name: 'Morocco' },
  { type: 'MZ', name: 'Mozambique' },
  { type: 'MM', name: 'Myanmar' },
  { type: 'NA', name: 'Namibia' },
  { type: 'NR', name: 'Nauru' },
  { type: 'NP', name: 'Nepal' },
  { type: 'NL', name: 'Netherlands' },
  { type: 'AN', name: 'Netherlands Antilles' },
  { type: 'NC', name: 'New Caledonia' },
  { type: 'NZ', name: 'New Zealand' },
  { type: 'NI', name: 'Nicaragua' },
  { type: 'NE', name: 'Niger' },
  { type: 'NG', name: 'Nigeria' },
  { type: 'NU', name: 'Niue' },
  { type: 'NF', name: 'Norfolk Island' },
  { type: 'MP', name: 'Northern Mariana Islands' },
  { type: 'NO', name: 'Norway' },
  { type: 'OM', name: 'Oman' },
  { type: 'PK', name: 'Pakistan' },
  { type: 'PW', name: 'Palau' },
  { type: 'PS', name: 'Palestinian Territory}, Occupied' },
  { type: 'PA', name: 'Panama' },
  { type: 'PG', name: 'Papua New Guinea' },
  { type: 'PY', name: 'Paraguay' },
  { type: 'PE', name: 'Peru' },
  { type: 'PH', name: 'Philippines' },
  { type: 'PN', name: 'Pitcairn' },
  { type: 'PL', name: 'Poland' },
  { type: 'PT', name: 'Portugal' },
  { type: 'PR', name: 'Puerto Rico' },
  { type: 'QA', name: 'Qatar' },
  { type: 'RE', name: 'Reunion' },
  { type: 'RO', name: 'Romania' },
  { type: 'RU', name: 'Russian Federation' },
  { type: 'RW', name: 'Rwanda' },
  { type: 'BL', name: 'Saint Barthelemy' },
  { type: 'SH', name: 'Saint Helena' },
  { type: 'KN', name: 'Saint Kitts And Nevis' },
  { type: 'LC', name: 'Saint Lucia' },
  { type: 'MF', name: 'Saint Martin' },
  { type: 'PM', name: 'Saint Pierre And Miquelon' },
  { type: 'VC', name: 'Saint Vincent And Grenadines' },
  { type: 'WS', name: 'Samoa' },
  { type: 'SM', name: 'San Marino' },
  { type: 'ST', name: 'Sao Tome And Principe' },
  { type: 'SA', name: 'Saudi Arabia' },
  { type: 'SN', name: 'Senegal' },
  { type: 'RS', name: 'Serbia' },
  { type: 'SC', name: 'Seychelles' },
  { type: 'SL', name: 'Sierra Leone' },
  { type: 'SG', name: 'Singapore' },
  { type: 'SK', name: 'Slovakia' },
  { type: 'SI', name: 'Slovenia' },
  { type: 'SB', name: 'Solomon Islands' },
  { type: 'SO', name: 'Somalia' },
  { type: 'ZA', name: 'South Africa' },
  { type: 'GS', name: 'South Georgia And Sandwich Isl.' },
  { type: 'ES', name: 'Spain' },
  { type: 'LK', name: 'Sri Lanka' },
  { type: 'SD', name: 'Sudan' },
  { type: 'SR', name: 'Suriname' },
  { type: 'SJ', name: 'Svalbard And Jan Mayen' },
  { type: 'SZ', name: 'Swaziland' },
  { type: 'SE', name: 'Sweden' },
  { type: 'CH', name: 'Switzerland' },
  { type: 'SY', name: 'Syrian Arab Republic' },
  { type: 'TW', name: 'Taiwan' },
  { type: 'TJ', name: 'Tajikistan' },
  { type: 'TZ', name: 'Tanzania' },
  { type: 'TH', name: 'Thailand' },
  { type: 'TL', name: 'Timor-Leste' },
  { type: 'TG', name: 'Togo' },
  { type: 'TK', name: 'Tokelau' },
  { type: 'TO', name: 'Tonga' },
  { type: 'TT', name: 'Trinidad And Tobago' },
  { type: 'TN', name: 'Tunisia' },
  { type: 'TR', name: 'Turkey' },
  { type: 'TM', name: 'Turkmenistan' },
  { type: 'TC', name: 'Turks And Caicos Islands' },
  { type: 'TV', name: 'Tuvalu' },
  { type: 'UG', name: 'Uganda' },
  { type: 'UA', name: 'Ukraine' },
  { type: 'AE', name: 'United Arab Emirates' },
  { type: 'GB', name: 'United Kingdom' },
  { type: 'US', name: 'United States' },
  { type: 'UM', name: 'United States Outlying Islands' },
  { type: 'UY', name: 'Uruguay' },
  { type: 'UZ', name: 'Uzbekistan' },
  { type: 'VU', name: 'Vanuatu' },
  { type: 'VE', name: 'Venezuela' },
  { type: 'VN', name: 'Vietnam' },
  { type: 'VG', name: 'Virgin Islands}, British' },
  { type: 'VI', name: 'Virgin Islands}, U.S.' },
  { type: 'WF', name: 'Wallis And Futuna' },
  { type: 'EH', name: 'Western Sahara' },
  { type: 'YE', name: 'Yemen' },
  { type: 'ZM', name: 'Zambia' },
  { type: 'ZW', name: 'Zimbabwe' }
];
